var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (collection, kind, remaining, total) {
jade_mixins["settings-section"] = jade_interp = function(id, name, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("id", id, true, true)) + (jade.attr("data-id", id, true, true)) + (jade.attr("data-name", label || name, true, true)) + " class=\"settings-section js-settings-section\"><h2 class=\"settings-section__name\">" + (jade.escape(null == (jade_interp = name) ? "" : jade_interp)) + "</h2><div" + (jade.cls(['settings-section__main','js-settings-section__main--' + (id) + ''], [null,true])) + "><div" + (jade.cls(['settings-' + (id) + ''], [true])) + ">");
block && block();
buf.push("</div></div></div>");
};
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"settings-quasi-infinite\"><div class=\"settings-quasi-infinite__total\">");
if ( total)
{
buf.push("" + (jade.escape((jade_interp = total) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = kind) == null ? '' : jade_interp)) + "");
}
buf.push("</div><div class=\"settings-quasi-infinite__collection js-settings-quasi-infinite__collection\">");
if ( collection && collection.length === 0)
{
buf.push("Nothing yet.");
}
buf.push("</div>");
if ( !collection || collection && collection.length > 0)
{
buf.push("<div class=\"settings-quasi-infinite__more\"><a" + (jade.attr("data-state", (!collection ? 'loading' : 'loaded'), true, true)) + " class=\"avant-garde-button-black is-block js-settings-quasi-infinite__more__button\">More");
if ( remaining)
{
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "(" + (jade.escape((jade_interp = remaining) == null ? '' : jade_interp)) + ")");
}
buf.push("</a></div>");
}
buf.push("</div>");
}
}, 'saved-artworks', 'Saved Artworks');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"settings-quasi-infinite\"><div class=\"settings-quasi-infinite__total\">");
if ( total)
{
buf.push("" + (jade.escape((jade_interp = total) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = kind) == null ? '' : jade_interp)) + "");
}
buf.push("</div><div class=\"settings-quasi-infinite__collection js-settings-quasi-infinite__collection\">");
if ( collection && collection.length === 0)
{
buf.push("Nothing yet.");
}
buf.push("</div>");
if ( !collection || collection && collection.length > 0)
{
buf.push("<div class=\"settings-quasi-infinite__more\"><a" + (jade.attr("data-state", (!collection ? 'loading' : 'loaded'), true, true)) + " class=\"avant-garde-button-black is-block js-settings-quasi-infinite__more__button\">More");
if ( remaining)
{
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "(" + (jade.escape((jade_interp = remaining) == null ? '' : jade_interp)) + ")");
}
buf.push("</a></div>");
}
buf.push("</div>");
}
}, 'artists', 'Artists');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"settings-quasi-infinite\"><div class=\"settings-quasi-infinite__total\">");
if ( total)
{
buf.push("" + (jade.escape((jade_interp = total) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = kind) == null ? '' : jade_interp)) + "");
}
buf.push("</div><div class=\"settings-quasi-infinite__collection js-settings-quasi-infinite__collection\">");
if ( collection && collection.length === 0)
{
buf.push("Nothing yet.");
}
buf.push("</div>");
if ( !collection || collection && collection.length > 0)
{
buf.push("<div class=\"settings-quasi-infinite__more\"><a" + (jade.attr("data-state", (!collection ? 'loading' : 'loaded'), true, true)) + " class=\"avant-garde-button-black is-block js-settings-quasi-infinite__more__button\">More");
if ( remaining)
{
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "(" + (jade.escape((jade_interp = remaining) == null ? '' : jade_interp)) + ")");
}
buf.push("</a></div>");
}
buf.push("</div>");
}
}, 'categories', 'Categories');
jade_mixins["settings-section"].call({
block: function(){
buf.push("<div class=\"settings-quasi-infinite\"><div class=\"settings-quasi-infinite__total\">");
if ( total)
{
buf.push("" + (jade.escape((jade_interp = total) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = kind) == null ? '' : jade_interp)) + "");
}
buf.push("</div><div class=\"settings-quasi-infinite__collection js-settings-quasi-infinite__collection\">");
if ( collection && collection.length === 0)
{
buf.push("Nothing yet.");
}
buf.push("</div>");
if ( !collection || collection && collection.length > 0)
{
buf.push("<div class=\"settings-quasi-infinite__more\"><a" + (jade.attr("data-state", (!collection ? 'loading' : 'loaded'), true, true)) + " class=\"avant-garde-button-black is-block js-settings-quasi-infinite__more__button\">More");
if ( remaining)
{
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "(" + (jade.escape((jade_interp = remaining) == null ? '' : jade_interp)) + ")");
}
buf.push("</a></div>");
}
buf.push("</div>");
}
}, 'galleries-institutions', 'Galleries & Institutions');}.call(this,"collection" in locals_for_with?locals_for_with.collection:typeof collection!=="undefined"?collection:undefined,"kind" in locals_for_with?locals_for_with.kind:typeof kind!=="undefined"?kind:undefined,"remaining" in locals_for_with?locals_for_with.remaining:typeof remaining!=="undefined"?remaining:undefined,"total" in locals_for_with?locals_for_with.total:typeof total!=="undefined"?total:undefined));;return buf.join("");
};
module.exports = template;